import { Row, Col } from "react-bootstrap";
import { formatDateTime } from "../patient-book-calendar/PatientBookCalendar";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";

const DayAvailabilities = ({ date, day, appointments }) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  return !isPhonePortrait ? (
    <Row className="my-3">
      <Col md={1} className="p-0">
        <p className="rg-11 mb-0 gray01">{day}</p>
        <p className="md-14">{formatDateTime(date)}</p>
      </Col>
      <Col>{appointments}</Col>
    </Row>
  ) : (
    <div className="my-3">
      <p className="bd-15 mb-2" key={day}>
        {`${day}, ${formatDateTime(date)}`}
      </p>
      {appointments}
    </div>
  );
};

export default DayAvailabilities;
